import React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "../lib/utils"
import { Button } from "./ui/button"
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react"
interface PaginationProps {
 currentPage: number
 totalPages: number
 totalItems?: number
 pageSize?: number
 onPageChange: (page: number) => void
 className?: string
 compact?: boolean
}

export function Pagination({
 currentPage,
 totalPages,
 totalItems,
 pageSize,
 onPageChange,
 className,
 compact = false,
}: PaginationProps) {
 const { t } = useTranslation()

 if (totalPages <= 1) return null

 const start = (currentPage - 1) * (pageSize || 10) + 1
 const end = Math.min(currentPage * (pageSize || 10), totalItems || 0)

 return (
 <div className={cn("flex items-center justify-between", className)}>
 {!compact && totalItems !== undefined && pageSize && (
 <p className="text-sm text-muted-foreground">
 {t('ui.showingRange', { start, end, total: totalItems })}
 </p>
 )}
 {compact && <div />}
 <div className="flex items-center gap-1">
 <Button
 variant="ghost" size="icon-sm"
onClick={() => onPageChange(1)}
 disabled={currentPage === 1}
 aria-label={t('ui.pagination.firstPage')}>
 <ChevronsRight className="h-4 w-4" aria-hidden />
 </Button>
 <Button
 variant="ghost" size="icon-sm"
onClick={() => onPageChange(currentPage - 1)}
 disabled={currentPage === 1}
 aria-label={t('ui.pagination.previousPage')}>
 <ChevronRight className="h-4 w-4" aria-hidden />
 </Button>
 <span className="px-3 text-sm tabular-nums">
 {currentPage} / {totalPages}
 </span>
 <Button
 variant="ghost" size="icon-sm"
onClick={() => onPageChange(currentPage + 1)}
 disabled={currentPage === totalPages}
 aria-label={t('ui.pagination.nextPage')}>
 <ChevronLeft className="h-4 w-4" aria-hidden />
 </Button>
 <Button
 variant="ghost" size="icon-sm"
onClick={() => onPageChange(totalPages)}
 disabled={currentPage === totalPages}
 aria-label={t('ui.pagination.lastPage')}>
 <ChevronsLeft className="h-4 w-4" aria-hidden />
 </Button>
 </div>
 </div>
 )
}
